import { render, staticRenderFns } from "./GroupAccountForm.vue?vue&type=template&id=556074fa&lang=pug"
import script from "./GroupAccountForm.vue?vue&type=script&lang=js"
export * from "./GroupAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports